import { API_ROOT } from 'constants'
import api from 'utils/api'
import axios from 'axios'

export const deleteSiteFiles = async (body, config) => await api.post(`${API_ROOT}/v3/site/delete`, body, config)

export const getSiteContents = async (body, config) => await api.get(`${API_ROOT}/v3/site`, body, config)

export const getSites = async (body, config) =>
  await api.post(`${API_ROOT}/v3/site/webhook`, body, {
    ...config,
    headers: {
      ...config?.headers,
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Expires: '0'
    }
  })

export const createSite = async (body, config, uploadProgress) =>
  await api.post(`${API_ROOT}/v3/site/create`, body, config, (event) => {
    const { total, loaded } = event
    uploadProgress({ total, loaded }, { size: total })
  })

export const updateSite = async (body, config, uploadProgress) =>
  await api.post(`${API_ROOT}/v3/site/update?domain=${config.domain}`, body, config, (event) => {
    const { total, loaded } = event
    uploadProgress({ total, loaded }, { size: total })
  })

export const getPresignedUrlCreate = async (config, formData) =>
  await api.post(`${API_ROOT}/v3/site/get-presigned-url/create`, formData, config)

export const getPresignedUrlUpdate = async (config, formData, isTransferRequestLink) =>
  await api.post(
    `${API_ROOT}/v3/site/get-presigned-url/${isTransferRequestLink ? 'transfer-request-link/' : ''}update?domain=${config.domain}`,
    formData,
    config
  )

export const processPresignedUrlCreate = async (config, formData) =>
  await api.post(`${API_ROOT}/v3/site/process-presigned-url/create`, formData, {
    ...config,
    headers: {
      ...config.headers,
      'Content-Type': 'multipart/form-data'
    }
  })

export const processPresignedUrlUpdate = async (config, formData, isTransferRequestLink) =>
  await api.post(
    `${API_ROOT}/v3/site/process-presigned-url/${isTransferRequestLink ? 'transfer-request-link/' : ''}update?domain=${config.domain}`,
    formData,
    {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data'
      }
    }
  )

export const classifierScan = async (body, config) => {
  try {
    return await api.post(`${API_ROOT}/v3/site/classifier-scan`, body, config)
  } catch (error) {
    console.error(error)
  }
}

export const transferRequestLinkCreate = async (config, formData, uploadProgress) =>
  await api.post(
    `${API_ROOT}/v3/site/transfer-request-link/create`,
    formData,
    config,
    uploadProgress
      ? (event) => {
          const { total, loaded } = event
          uploadProgress({ total, loaded }, { size: total })
        }
      : undefined
  )

export const transferRequestLinkUpdate = async (config, formData, uploadProgress) =>
  await api.post(
    `${API_ROOT}/v3/site/transfer-request-link/update`,
    formData,
    config,
    uploadProgress
      ? (event) => {
          const { total, loaded } = event
          uploadProgress({ total, loaded }, { size: total })
        }
      : undefined
  )
